import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { tablaMultas } from '../../../../shared/data/tables/tabla-multas';
import { NgbdSortableHeader, SortEvent } from '../../../../shared/directives/NgbdSortableHeader';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { Component, HostListener, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { VehiclesService } from '../../../../shared/services/vehicles.service';
import { Router } from '@angular/router';
import jsPDF from 'jspdf';
import { Utils } from '../../../../shared/utils/Utils';
import { gpcGoogleService } from '../../../../shared/services/gpcGoogle.service';
import { TiposerviciosDocumentosService } from '../../../../shared/services/tiposerviciosdocumento.service';
import { AdministracionService } from '../../../../shared/services/administracion.services';
import { Administracion } from '../../../../shared/model/administracion.model';
import { PDFDocument } from 'pdf-lib';
import { AuthService } from '../../../../shared/services/auth.service';
import { AdminSeafLoadingService } from '../../../../shared/services/adminseaf-loading.service';
import { firstValueFrom } from 'rxjs';
import { Mantenimiento, MantenimientoService, RespuestaMantenimientos } from '../../../../shared/services/mantenimientos.service';
const Swal = require("sweetalert2");

@Component({
  selector: 'app-afiliados-activos',
  templateUrl: './afiliados-activos.component.html',
  styleUrls: ['./afiliados-activos.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class AfiliadosActivosComponent implements OnInit {
  
    /**
     * Devuelve un array de strings con los campos relevantes para filtrado y ordenamiento
     */
    private getVehicleFields(vehicle: any): string[] {
      return [
        vehicle.placa,
        vehicle.interno,
        vehicle.marcas?.marca,
        vehicle.modelo,
        vehicle.tipoVehiculo?.tipos,
        vehicle.Idpropietario,
        vehicle.propietario?.primernombre,
        vehicle.propietario?.segundonombre,
        vehicle.propietario?.papellidos,
        vehicle.propietario?.seapellidos,
        vehicle.tipoRelacion?.relacion,
        vehicle.tarjetasOperaciones?.[0]?.fecha_vencimiento,
        vehicle.historialSoat?.[0]?.vencimiento_soat,
        vehicle.historialCda?.[0]?.vcda,
        vehicle.historialBimestral?.[0]?.proxima_revision,
        vehicle.historialContractual?.[0]?.fecha_vencimientoRCC,
        vehicle.historialExtraContractual?.[0]?.fecha_vencimientoRCE
      ];
    }
  public selected = [];
  public searchText: string = '';
  private _filteredCache: { search: string, result: any[] } = { search: '', result: [] };

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;
  isSelected = false;

  disabled = true;
  selectedEstado: any;
  vehicles: any[] = [];
  loading: boolean = false;
  tarjetas: any;
  mostrandoToast = false;
  layoutConfig = {};
  administraciones: Administracion[] = [];
  urlPdfRut: any;
  mantenimientos: Mantenimiento[] = [];
  respuestaMantenimientos: RespuestaMantenimientos | null = null;
  //mantenimientos: Mantenimiento[] = []; // Esta línea es redundante y se puede eliminar
  onNavChange1(changeEvent: NgbNavChangeEvent) {
    if (changeEvent.nextId === 5) {
      changeEvent.preventDefault();
    }
  }


  public show: boolean = false
  openDropdown: any = null; // Variable para controlar qué menú está abierto
  openDropdown2: any = null; // Variable para controlar qué menú está abierto
  sortColumn: string = '';
  sortDirection: string = 'asc'; // 'asc' o 'desc'
  dropdownStates: boolean[] = [];
  filteredTableItems: any[] = [];
  altura: number = 0;
  ancho: number = 0;
  posicionX: number = 0;
  posicionY: number = 0;

  constructor(
    private vehicleService: VehiclesService,
    private router: Router,
    private gpcGoogle: gpcGoogleService,
    private tiposerviciodocumentoService: TiposerviciosDocumentosService,
    private administracionesServices: AdministracionService,
    private auth: AuthService,
    private loadingService: AdminSeafLoadingService,
    private mantenimientoService: MantenimientoService
  ) { }

 

  ngOnInit() {
    this.selectedEstado = "";
    this.listarActivos();
    this.cargarDataAdmin();

  }

  pageSize1: number = 5;
  page1: number = 1;
  totalItems: number = 0;

  @HostListener('document:click', ['$event'])
  closeDropdown(event: Event) {
    this.openDropdown = null;
    this.openDropdown2 = null;
  }

  stopPropagation(event: Event) {
    event.stopPropagation(); // Evita que el clic dentro del dropdown cierre el menú
  }
  // Función para ordenar las columnas
  onSort({ column, direction }: SortEvent) {
    // Restablecemos la dirección de orden de todas las columnas
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // Establecemos la columna y dirección de orden
    // this.service.sortColumn = column;
    // this.service.sortDirection = direction;
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.filteredTableItems = [...this.filteredTableItems].sort((a, b) => {
      const valueA = this.getVehicleFields(a)[column] || '';
      const valueB = this.getVehicleFields(b)[column] || '';
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }
      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  get filteredinfracciones() {
    if (this._filteredCache.search === this.searchText && this._filteredCache.result.length > 0) {
      return this._filteredCache.result;
    }
    if (!this.searchText) {
      this._filteredCache = { search: '', result: this.vehicles };
      return this.vehicles;
    }
    const term = this.searchText.toLowerCase();
    const result = this.vehicles.filter(vehicle => {
      const combined = this.getVehicleFields(vehicle).map(val => (val ? val.toString().toLowerCase() : '')).join(' ');
      return combined.includes(term);
    });
    this._filteredCache = { search: this.searchText, result };
    return result;
  }

  toggleDropdown(index: number) {
    this.dropdownStates = this.dropdownStates.map((state, i) => (i === index ? !state : false));
  }


  async listarActivos(): Promise<void> {
    this.loading = true;
    try {
      const data = await this.vehicleService.getVehiclesEstadoRelacion().toPromise();
      if (data?.vehicles) {
        this.vehicles = data.vehicles.map(vehicle => ({ ...vehicle }));
        this.filteredTableItems = this.vehicles;
      } else {
        this.vehicles = [];
        this.filteredTableItems = [];
      }
    } catch (err) {
      console.error("Error cargando propietarios", err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo cargar la lista de vehículos',
        confirmButtonText: 'Aceptar'
      });
    } finally {
      this.loading = false;
    }
  }

  estadoMap: { [key: string]: string } = {
    "VIGENTE": "badge badge-success",
    "POR VENCER": "badge badge-warning",
    "VENCIDO": "badge badge-secondary",
  };

  getEstadoColor(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-primary"; // Si no hay estado, usa gris
  }


  //recibe el id de la tabla vista, nombre con el que descargará el archivo, titulo del documento
  exportToPDF(tableId: string, nameFile: string, titleFile: string) {
    Utils.exportToPDF(tableId, nameFile, titleFile);
  }


  exportarExcel(tableId: string, nameFile: string) {
    Utils.exportVisibleTableToExcel(tableId, nameFile);
  }

  avisoInactivarPersona(placa: string) {
    Swal.fire({
      title: "INACTIVAR",
      text: `¿Desea inactivar el vehículo con placa: ${placa}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.vehicleService.inactivateVehicle(placa).subscribe({
          next: (response) => {
            Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: response.message,
              confirmButtonText: 'Aceptar'
            });
            this.listarActivos(); // 🔹 Solo refrescar si es exitoso
          },
          error: (error) => {
            console.error('Error:', error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.error?.message || 'No se pudo inactivar el vehículo',
              confirmButtonText: 'Aceptar'
            });
          }
        });
      }
    });
  }

  filterData() {
    // Usar el getter optimizado
    this.filteredTableItems = this.filteredinfracciones;
    this.page1 = 1;
  }


  editarPersona(placa: string) {
    console.log('Redirigiendo a editar vehículo con placa:', placa);
    this.router.navigate(['/vehiculo/editar-vehiculo', placa]);
  }

  CrearVehiculo() {
    this.router.navigate(['/vehiculos/nuevos']);
  }

  cargarDocumentos(placa: string, servicio: BigInteger) {
    this.router.navigate(['/digital/vehiculos', placa, servicio]);
  }

  addFooter(doc: jsPDF, currentPage: number, totalPages: number) {
    const pageHeight = doc.internal.pageSize.height;
    const now = new Date();
    const fecha = now.toLocaleDateString("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
    const hora = now.toLocaleTimeString("es-CO", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
    const fechaHora = `${fecha} - ${hora}`;

    doc.setFont("helvetica", "italic");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);

    // Línea de pie centrada
    // Enlace clicable en el centro
    const linkText = "Generado desde Admin SEAF – INDESOFT SAS";
    doc.textWithLink(linkText, 105, pageHeight - 12, {
      url: "https://indesoftsas.com",
      align: "center"
    });

    // Fecha y hora a la izquierda
    doc.text(
      `${fechaHora}`,
      10,
      pageHeight - 5
    );

    // Número de página a la derecha
    doc.text(
      `Página ${currentPage} de ${totalPages}`,
      200,
      pageHeight - 5,
      { align: "right" }
    );
  }

  addHeader(doc: jsPDF,title:string) {
    const pageWidth = 216;       // Ancho total en mm (Letter)
    const marginLeft = 5;       // Margen izquierdo deseado
    const marginRight = 5;      // Margen derecho igual para simetría
    const rectY = 3;            // Distancia desde la parte superior
    const headerHeight = 20;     // Altura del encabezado
    const rectWidth = pageWidth - marginLeft - marginRight;

    // Dibujar el rectángulo del encabezado
    doc.setDrawColor(0, 0, 0);   // Borde negro
    doc.setLineWidth(0.5);       // Grosor del borde
    doc.rect(marginLeft, rectY, rectWidth, headerHeight);

    // Título centrado dentro del rectángulo
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);

    const text = title;
    const centerX = marginLeft + rectWidth / 2;
    const textY = rectY + 12; // Ajuste vertical para ubicar el texto dentro del rectángulo

    doc.text(text, centerX, textY, { align: "center" });
  }

  async addHeaderImages(
    doc: jsPDF,
    gpcGoogle: any,
    imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number }>
  ) {
    const getSignedUrlSafe = async (path: string) => {
      try {
        const res = await gpcGoogle.getSignedUrl(path).toPromise();
        return res?.url || null;
      } catch {
        return null;
      }
    };

    const getImageBase64Safe = async (url: string | null) => {
      if (!url) return null;
      try {
        return await gpcGoogle.getImageBase64(url);
      } catch {
        return null;
      }
    };

    const imageKeys = Object.entries(imageMap);
    const signedUrls = await Promise.all(
      imageKeys.map(([_, img]) => getSignedUrlSafe(img.path))
    );

    const base64Images = await Promise.all(
      signedUrls.map((url) => getImageBase64Safe(url))
    );

    
    base64Images.forEach((base64, idx) => {
      
      const { x, y, w, h } = imageKeys[idx][1];
      if (base64) {
        doc.addImage(base64, "JPG", x, y, w, h, undefined, "FAST");
      } else {
        // Mostrar texto si no se pudo cargar la imagen
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text("", x + 2, y + h / 2, { maxWidth: w });
      }
    });
  }

 async addImagesToPdfConPaginas(
       doc: jsPDF,
       gpcGoogle: any,
       imageMap: Record<
         string,
         { path: string; x: number; y: number; w: number; h: number; title?: string; group?: string }
       >
     ): Promise<void> {
       const imageSiglas = new Set(['FP', 'FF', 'FD', 'FI','LT','LTP']); // Solo fotografías
       const pdfSiglas = new Set(['CDA', 'SOAT', 'BIM', 'RCC', 'RCE', 'CVF', 'TO']); // Documentos que siempre deben tratarse como PDF
       // 1. Preparar clave-imagen con configuraciones, excluyendo FIN1 y FIN2
       const imageEntries = Object.entries(imageMap).filter(([key, config]) => {
         const group = config.group || key;
         return group !== 'FIN1' && group !== 'FIN2' && key !== 'FIN1' && key !== 'FIN2';
       });

       // 2. Obtener URLs firmadas y la extensión usada en paralelo
       const signedUrlAndExtResults = await Promise.all(
         imageEntries.map(async ([key, config]) => {
           const normalizedKey = (key || '').toUpperCase();
           const normalizedGroup = (config.group || '').toUpperCase();
           const isForcedPdf = pdfSiglas.has(normalizedKey) || pdfSiglas.has(normalizedGroup);
           const isPhoto = !isForcedPdf && (imageSiglas.has(normalizedKey) || imageSiglas.has(normalizedGroup));
           const extensions = isPhoto ? ['jpg', 'jpeg', 'png'] : ['pdf'];

           for (const ext of extensions) {
             const basePath = config.path.replace(/\.[a-zA-Z0-9]+$/, '');
             const tryPath = `${basePath}.${ext}`;
             try {
               const res = await gpcGoogle.getSignedUrl(tryPath).toPromise();
               if (res?.url) {
                 return { url: res.url, ext };
               }
             } catch {
               // continuar con la siguiente extensión
             }
           }
           return { url: null, ext: null };
         })
       );
   
       // 3. Obtener imágenes base64 en paralelo (solo si hay URL válida)
       const base64Results = await Promise.all(
         signedUrlAndExtResults.map(async (result) => {
           if (!result.url) return null;
           try {
             return await gpcGoogle.getImageBase64(result.url);
           } catch {
             return null;
           }
         })
       );
   
       // 4. Agrupar por grupo
       const grouped: Record<string, {
         key: string;
         base64: string | null;
         x: number;
         y: number;
         w: number;
         h: number;
         title?: string;
         ext?: string;
       }[]> = {};
   
       imageEntries.forEach(([key, config], idx) => {
         const groupKey = config.group || key;
         if (!grouped[groupKey]) grouped[groupKey] = [];
         
         grouped[groupKey].push({
           key,
           base64: base64Results[idx],
           x: config.x,
           y: config.y,
           w: config.w,
           h: config.h,
          title: config.title,
           ext: signedUrlAndExtResults[idx].ext || undefined,
         });
       });
   
       
       // 5. Recolectar URLs de PDFs externos
       const pdfUrls: string[] = [];
      
   doc.addPage();
       for (const group of Object.values(grouped)) {
        
   
         for (const img of group) {
           const isPhotoSlot = imageSiglas.has((img.key || '').toUpperCase());
           const padding = 2;
           const titleHeight = 10;
           const adjustedY = img.y + titleHeight;
   
         // console.log(img.title);
           // Título
           if (isPhotoSlot && (img.title?.includes("FOTOGRAFÍA PRINCIPAL") 
             || img.title?.includes("FOTOGRAFÍA FRONTAL")
            || img.title?.includes("FOTOGRAFÍA LADO DERECHO")
             || img.title?.includes("FOTOGRAFÍA LADO IZQUIERDO")
              || img.title?.includes("LICENCIA DE TRANSITO FRONTAL")
              || img.title?.includes("LICENCIA DE TRANSITO POSTERIOR")
           )) {
             const titleText = img.title.toUpperCase();
             doc.setFillColor(230, 230, 230);
             doc.rect(img.x, img.y, img.w, titleHeight, "F");
             doc.setFont("helvetica", "bold");
             doc.setFontSize(12);
             doc.setTextColor(40, 40, 40);
             // Centrar usando align: 'center' y el centro del rectángulo
             doc.text(titleText, img.x + img.w / 2, img.y + 8, { align: "center" });
              // Marco
           doc.setDrawColor(50);
           doc.setLineWidth(0.3);
           doc.rect(img.x, adjustedY, img.w, img.h);
   
           }
   
          
           if (img.base64) {
             let format = "JPG";
             let ext = img.ext ? img.ext.toLowerCase() : "jpg";
             if (ext === "pdf") {
               // Asegurar que la base64 tenga el prefijo correcto para PDF
               let pdfBase64 = img.base64;
               if (!pdfBase64.startsWith('data:application/pdf;base64,')) {
                 pdfBase64 = 'data:application/pdf;base64,' + pdfBase64;
               }
               pdfUrls.push(pdfBase64);
               // Mostrar mensaje de que se fusionará al final
              
             } else if (isPhotoSlot) {
               if (ext === "png") format = "PNG";
               else if (ext === "jpeg" || ext === "jpg") format = "JPG";
               doc.addImage(
                 img.base64,
                 format,
                 img.x + padding,
                 adjustedY + padding,
                 img.w - padding * 2,
                 img.h - padding * 2,
                 undefined,
                 "FAST"
               );
             }
           } 
         }
       }
   
       // 6. Si hay PDFs externos, fusionar todos al final
       if (pdfUrls.length > 0) {
        // console.log(pdfUrls.length);
         // Obtener el PDF generado con jsPDF como Uint8Array
         const pdfBytes = doc.output('arraybuffer');
         const mergedPdf = await PDFDocument.create();
         const jsPdfDoc = await PDFDocument.load(pdfBytes);
         const jsPdfPages = await mergedPdf.copyPages(jsPdfDoc, jsPdfDoc.getPageIndices());
         jsPdfPages.forEach((page) => mergedPdf.addPage(page));
   
         // Descargar y fusionar cada PDF externo
         for (const url of pdfUrls) {
           try {
             let remotePdfBytes: Uint8Array;
             // Detectar si es base64 o URL
             if (typeof url === 'string' && url.startsWith('data:application/pdf;base64,')) {
               // Es base64, convertir a Uint8Array
               const base64 = url.split(',')[1];
               const binaryString = atob(base64);
               const len = binaryString.length;
               const bytes = new Uint8Array(len);
               for (let i = 0; i < len; i++) {
                 bytes[i] = binaryString.charCodeAt(i);
               }
               remotePdfBytes = bytes;
             } else {
               // Es una URL, descargar
               remotePdfBytes = await this.fetchPdf(url);
             }
             const remoteDoc = await PDFDocument.load(remotePdfBytes);
             const remotePages = await mergedPdf.copyPages(remoteDoc, remoteDoc.getPageIndices());
             remotePages.forEach((page) => mergedPdf.addPage(page));
           } catch (e) {
             console.warn("No se pudo fusionar un PDF externo:", e);
           }
         }
         // Mostrar el PDF fusionado
         const mergedBytes = await mergedPdf.save();
         // Convertir Uint8Array a ArrayBuffer para compatibilidad Blob
         const arrayBuffer = mergedBytes.buffer.slice(mergedBytes.byteOffset, mergedBytes.byteOffset + mergedBytes.byteLength);
         const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
         const url = URL.createObjectURL(blob);
         window.open(url, '_blank');
         return;
       } else {
         // Si no hay PDFs externos, mostrar el PDF generado normalmente
         const blob = doc.output('blob');
         const url = URL.createObjectURL(blob);
              
        window.open(url, '_blank');
        this.loadingService.actualizarPaso(
        'pdf',
        { estado: 'completado' },
        'Información cargada correctamente'
      );
         return;
       }
     }

  
sortLayoutConfig(layoutConfig, isFotografica) {
  const order = [
    "FP", "FF", "FD", "FI",        // Fotos (sin interiores)
    "LT", "LTP",                   // Licencias tránsito
    
   
  ];

    let excluded: string[] = [];

  if (isFotografica === 0) {
    excluded = ["FIN1", "FIN2"]; // Excluir interiores solo si no es fotográfico
  }

  const sortedConfig = {};

  // 1. Agregar claves en orden específico
  for (const key of order) {
    if (layoutConfig[key]) {
      sortedConfig[key] = layoutConfig[key];
    }
  }

  // 2. Agregar cualquier otro no incluido ya ni excluido
  for (const key in layoutConfig) {
    if (!sortedConfig[key] && !excluded.includes(key)) {
      sortedConfig[key] = layoutConfig[key];
    }
  }

  return sortedConfig;
}


  ValidarDocumentos(idServices: number, placa: string,isFotografica:number) {
    this.tiposerviciodocumentoService
      .getTiposervicioDocumentoById(idServices)
      .subscribe(
        (servicio) => {
          const documentos = servicio;
          // Obtener nit de la administración activa
          const nit = this.administraciones[0]?.nit || '';
          // Generar imageMap
       
          const imageMap = this.generarImageMap(documentos, String(placa), nit.toString());
         // console.log('imageMap generado:', imageMap);
          // Si quieres guardarlo en layoutConfig para usarlo después:
          this.layoutConfig = imageMap;
        },
        (error) => {
          console.error("Error obteniendo el servicio:", error);
        }
      );
  }

  /**
   * Genera un imageMap (imageKeys) para PDF a partir del array de documentos, placa y nit.
   * @param documentos Array de documentos (como el del ejemplo del usuario)
   * @param placa Placa del vehículo
   * @param nit Nit de la empresa/administración
   * @returns imageMap para usar en addImagesToPdfConPaginas
   */
  private generarImageMap(
    documentos: any[],
    placa: string,
    nit: string
  ): Record<string, { path: string; x: number; y: number; w: number; h: number; title?: string; group?: string }> {
    const imageMap: Record<string, { path: string; x: number; y: number; w: number; h: number; title?: string; group?: string }> = {};
    for (const doc of documentos) {
      
      const documento = doc.documento;
      const sigla = documento.sigla.trim();
     
      // Usar el primer formato permitido para armar el path
     if(documento.cargarDigital==1){
      const path = `${nit}/vehiculos/${placa}/${sigla}_${placa}`;
      imageMap[sigla] = {
        path,
        x: documento.x,
        y: documento.y,
        w: documento.w,
        h: documento.h,
        title: documento.tipoDocumento ? documento.tipoDocumento.trim().toUpperCase() : undefined,
        group: documento.group || undefined
      };
     } 
      
    }
    
    return imageMap;
  }


  async addphotoToPdf(
  doc: jsPDF,
  gpcGoogle: any,
  imageMap: Record<
    string,
    {
      path: string;
      x: number;
      y: number;
      w: number;
      h: number;
      title?: string;
      group?: string;
    }
  >
): Promise<void> {

  const imageSiglas = new Set(['FP', 'FF', 'FD', 'FI']);
  const pdfSiglas = new Set(['CDA', 'SOAT', 'BIM', 'RCC', 'RCE', 'CVF', 'TO']);

  const imageEntries = Object.entries(imageMap).filter(([key, config]) => {
    const group = (config.group || key).toUpperCase();
    const normalizedKey = key.toUpperCase();

    return !['LT', 'LTP'].includes(group)
      && !['LT', 'LTP'].includes(normalizedKey);
  });

  if (imageEntries.length === 0) {
    return;
  }

  const signedUrlAndExtResults = await Promise.all(
    imageEntries.map(async ([key, config]) => {
      const normalizedKey = key.toUpperCase();
      const normalizedGroup = (config.group || '').toUpperCase();

      const isForcedPdf =
        pdfSiglas.has(normalizedKey) ||
        pdfSiglas.has(normalizedGroup);

      const isPhoto =
        !isForcedPdf &&
        (
          imageSiglas.has(normalizedKey) ||
          imageSiglas.has(normalizedGroup)
        );

      const extensions = isPhoto
        ? ['jpg', 'jpeg', 'png']
        : ['pdf'];

      const basePath = config.path.replace(/\.[a-zA-Z0-9]+$/, '');

      for (const ext of extensions) {
        try {
          const res = await firstValueFrom(
            gpcGoogle.getSignedUrl(`${basePath}.${ext}`)
          ) as { url?: string };

          if (res?.url) {
            return { url: res.url, ext };
          }
        } catch (error) {
          console.warn(`No se encontró ${basePath}.${ext}`);
        }
      }

      return { url: null, ext: null };
    })
  );

  const base64Results = await Promise.all(
    signedUrlAndExtResults.map(async result => {
      if (!result.url) {
        return null;
      }

      try {
        return await gpcGoogle.getImageBase64(result.url);
      } catch (error) {
        console.warn('No se pudo cargar una imagen del PDF:', error);
        return null;
      }
    })
  );

  const grouped: Record<string, {
    key: string;
    base64: string | null;
    x: number;
    y: number;
    w: number;
    h: number;
    title?: string;
    ext?: string;
  }[]> = {};

  imageEntries.forEach(([key, config], idx) => {
    const groupKey = config.group || key;

    if (!grouped[groupKey]) {
      grouped[groupKey] = [];
    }

    grouped[groupKey].push({
      key,
      base64: base64Results[idx],
      x: config.x,
      y: config.y,
      w: config.w,
      h: config.h,
      title: config.title,
      ext: signedUrlAndExtResults[idx].ext || undefined
    });
  });

  // Agregar una página para las fotografías y documentos.
  doc.addPage();

  const titulosFotografia = [
    'FOTOGRAFÍA PRINCIPAL',
    'FOTOGRAFÍA FRONTAL',
    'FOTOGRAFÍA LADO DERECHO',
    'FOTOGRAFÍA LADO IZQUIERDO',
    'FOTOGRAFÍA INTERIOR 1',
    'FOTOGRAFÍA INTERIOR 2'
  ];

  for (const group of Object.values(grouped)) {
    for (const img of group) {

      const normalizedKey = img.key.toUpperCase();
      const isPhotoSlot = imageSiglas.has(normalizedKey);

      const padding = 2;
      const titleHeight = 10;
      const adjustedY = img.y + titleHeight;

      const mostrarTitulo = titulosFotografia.some(titulo =>
        img.title?.toUpperCase().includes(titulo)
      );

      if (mostrarTitulo) {
        doc.setFillColor(230, 230, 230);
        doc.rect(img.x, img.y, img.w, titleHeight, 'F');

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(12);
        doc.setTextColor(40, 40, 40);

        doc.text(
          (img.title || '').toUpperCase(),
          img.x + img.w / 2,
          img.y + 7,
          { align: 'center' }
        );
      }

      // Marco del área de la fotografía.
      doc.setDrawColor(50);
      doc.setLineWidth(0.3);
      doc.rect(img.x, adjustedY, img.w, img.h);

      if (img.base64 && isPhotoSlot) {
        const ext = (img.ext || 'jpg').toLowerCase();
        const format = ext === 'png' ? 'PNG' : 'JPEG';

        doc.addImage(
          img.base64,
          format,
          img.x + padding,
          adjustedY + padding,
          img.w - padding * 2,
          img.h - padding * 2,
          undefined,
          'FAST'
        );

        // Dibujar el borde encima de la imagen.
        doc.setDrawColor(50);
        doc.setLineWidth(0.3);
        doc.rect(img.x, adjustedY, img.w, img.h);
      }
    }
  }

  // La función modifica el documento, pero no lo abre.
  // La apertura se realizará una sola vez desde el método principal.
}
 
  async ExportarFichaCalidad(placa: string, servicio: number) {
     
  var isMantenimientoIncluido = false;

  const result = await Swal.fire({
    title: '¿Generar ficha con mantenimientos?',
    text: '¿Desea incluir los mantenimientos recientes del vehículo en la ficha de calidad?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sí, incluir',
    cancelButtonText: 'No, continuar sin ellos',
    confirmButtonColor: '#7366ff',
    cancelButtonColor: '#6c757d',
    reverseButtons: true
  });

  if (result.isConfirmed) {
    isMantenimientoIncluido = true;
  } else if (
    result.isDismissed &&
    result.dismiss === Swal.DismissReason.cancel
  ) {
    isMantenimientoIncluido = false;
  } else {
    return;
  }

    this.loadingService.mostrar(
      'Preparando ficha de calidad',
      [
        {
          id: 'preparando',
          nombre: 'Preparando ficha',
          icono: '📝',
          visible: true,
          estado: 'cargando'
        },
        {
          id: 'vehiculo',
          nombre: 'Datos del vehículo',
          icono: '🚍',
          visible: true,
          estado: 'pendiente'
        },
        {
          id: 'documentos',
          nombre: 'Validando documentos',
          icono: '📄',
          visible: true,
          estado: 'pendiente'
        },
        {
          id: 'pdf',
          nombre: 'Generando PDF',
          icono: '📑',
          visible: true,
          estado: 'pendiente'
        }
      ], "Generando ficha de calidad"
    );

    //vamos a consultar los mantenimientos del vehículo los ultimos 6 meses

    this.mantenimientoService
      .buscarMantenimientosPorFiltros(
        [placa],
        this.obtenerFechaSeisMesesAtras(),
        new Date().toISOString().substring(0, 10)
      )
      .subscribe({
        next: (resp) => {
          // Guardar el response completo
          this.respuestaMantenimientos = resp;

          // Extraer los mantenimientos de los vehículos
          this.mantenimientos = (resp?.vehiculos ?? [])
            .flatMap(vehiculo => vehiculo.mantenimientos ?? []);

        //  console.log('Respuesta completa:', this.respuestaMantenimientos);
         // console.log('Mantenimientos obtenidos:', this.mantenimientos);
        },
        error: (error) => {
          console.error('Error al consultar mantenimientos:', error);
        }
      });
    // 1. Preparar datos
    this.loadingService.actualizarPaso(
      'preparando',
      { estado: 'completado' },
      'Buscando información del vehículo'
    );

    this.loadingService.actualizarPaso(
      'vehiculo',
      { estado: 'cargando' }
    );

    this.ValidarDocumentos(servicio, placa, 0);

    this.loadingService.actualizarPaso(
      'documentos',
      { estado: 'completado' },
      'Documentos revisados'
    );
    //this.mostrandoToast = true;




    const vehiculo = this.vehicles.find(v => v.placa === placa);
    // console.log(vehiculo);
    if (!vehiculo) {
      console.error("Vehículo no encontrado");
      return;
    }

    this.loadingService.actualizarPaso(
      'vehiculo',
      { estado: 'completado' },
      'Información del vehículo cargada'
    );



    // 3. Generar el PDF
    this.loadingService.actualizarPaso(
      'pdf',
      { estado: 'cargando' },
      'Generando ficha de calidad'
    );
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "letter",
    });

    this.addHeader(doc, 'HOJA DE VIDA VEHÍCULAR');
    await this.addHeaderImages(doc, this.gpcGoogle, {
      supertransporte: { path: "ministerio/supertransporte.png", x: 170, y: 7, w: 35, h: 12 },
      logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
    },);

    let y = 35;
    // Estilo del rectángulo gris
    doc.setFillColor(230, 230, 230); // Gris claro y moderno
    doc.setDrawColor(200); // Borde gris suave
    doc.roundedRect(5, 25, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos

    // Estilo del texto
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40); // Gris oscuro
    doc.text("INFORMACIÓN DEL VEHÍCULO", 105, 33, { align: "center" });
  //  console.log(vehiculo);
    const infoVehiculo = [
      ["PLACA:", vehiculo.placa],
      ["EMPRESA:", vehiculo.nombreEmpresa?.nombre || ''],
      ["MARCA:", vehiculo.marcas?.marca || ''],
      ["CLASE:", vehiculo.tipoVehiculo?.tipos || ''],
      ["MODELO:", vehiculo.modelo],
      ["CAPACIDAD:", vehiculo.capacidad + " Pasajeros"],
      ["COLOR:", vehiculo.color],
      ["LÍNEA:", vehiculo.linea],
      ["CARROCERÍA:", vehiculo.carroceria],
      ["CILINDRAJE:", vehiculo.cilindraje],
      ["MOTOR:", vehiculo.motor],
      ["SERIE:", vehiculo.serie],
      ["CHASIS:", vehiculo.chasis],
      ["# MATRICULA:", vehiculo.matricula],
      ["ORGANISMO:", vehiculo.organismo],

      ["AFILIACIÓN:", vehiculo.afiliacion],
      ["RELACIÓN:", vehiculo.tipoRelacion?.relacion || ''],
      ["PROPIETARIO:", `${vehiculo.propietario?.primernombre} ${vehiculo.propietario?.segundonombre} ${vehiculo.propietario?.papellidos} ${vehiculo.propietario?.seapellidos}`.trim()]
    ];

    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");

    let startY = 37;
    const rowHeight = 7;
    const titleWidth = 35;
    const valueWidth = 68;
    const startX = 5;

    for (let i = 0; i < infoVehiculo.length; i++) {
      const row = Math.floor(i / 2);
      const col = i % 2;

      const x = startX + col * (titleWidth + valueWidth + 0);
      const y = startY + row * rowHeight;

      // Fondo gris para el título
      doc.setFillColor(230, 230, 230);
      doc.setDrawColor(200);
      doc.rect(x, y, titleWidth, rowHeight, 'FD');

      // Fondo blanco para el valor
      doc.setFillColor(255, 255, 255);
      doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

      // Texto del título
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text(infoVehiculo[i][0], x + 2, y + 5.5);

      // Texto del valor
      doc.setFont("helvetica", "normal");
      doc.text(String(infoVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
    }



    doc.setFillColor(230, 230, 230); // Gris claro y moderno
    doc.setDrawColor(200); // Borde gris suave
    doc.roundedRect(5, y + 70, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos  
    // Estilo del texto
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40); // Gris oscuro
    doc.text(
      "SEGURO OBLIGATORIO DE ACCIDENTES DE TRÁNSITO (SOAT)",
      105,
      y + 77,
      { align: "center" }
    );

    const soat = vehiculo.historialSoat?.[0];

    doc.setFontSize(9);

    const soatVehiculo = [
      ["ASEGURADORA:", soat?.empresa?.nombre ?? ""],
      ["ID SOAT:", soat?.id_soat ?? ""],
      [
        "EXPEDICIÓN:",
        soat?.fecha_soat
          ? this.formatFechaDDMMYYYY(soat.fecha_soat)
          : ""
      ],
      [
        "VENCIMIENTO:",
        soat?.vencimiento_soat
          ? this.formatFechaDDMMYYYY(soat.vencimiento_soat)
          : ""
      ],
      ["ESTADO:", soat?.estadoCalculado?.estado ?? ""]
    ];

    startY = 37 + 80;
    for (let i = 0; i < soatVehiculo.length; i++) {
      const row = Math.floor(i / 2);
      const col = i % 2;

      const x = startX + col * (titleWidth + valueWidth + 0);
      const y = startY + row * rowHeight;

      // Fondo gris para el título
      doc.setFillColor(230, 230, 230);
      doc.setDrawColor(200);
      doc.rect(x, y, titleWidth, rowHeight, 'FD');

      // Fondo blanco para el valor
      doc.setFillColor(255, 255, 255);
      doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

      // Texto del título
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text(soatVehiculo[i][0], x + 2, y + 5.5);

      // Texto del valor
      doc.setFont("helvetica", "normal");
      doc.text(String(soatVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
    }



    doc.setFillColor(230, 230, 230); // Gris claro y moderno
    doc.setDrawColor(200); // Borde gris suave
    doc.roundedRect(5, y + 108, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos  
    // Estilo del texto
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40, 40, 40); // Gris oscuro
    doc.text("REVISIÓN TÉCNICO MECÁNICA (RTM)", 105, y + 116, { align: "center" });

    doc.setFontSize(9);
    const cda = vehiculo.historialCda?.[0];
    const cdaVehiculo = [
      ["CDA:", cda?.empresa?.nombre.replace("CENTRO DE DIAGNOSTICO AUTOMOTOR", "CDA") || 'SIN DATO'],
      ["ID CDA:", cda?.idcda || 'SIN DATO'],
      ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(cda?.fechacda || '')],
      ["VENCIMIENTO:", this.formatFechaDDMMYYYY(cda?.vcda || '')],
      ["ESTADO:", cda?.estadoCalculado?.estado || 'SIN DATO']


    ];
    doc.setFontSize(9);
    startY = 37 + 118;
    for (let i = 0; i < cdaVehiculo.length; i++) {
      const row = Math.floor(i / 2);
      const col = i % 2;

      const x = startX + col * (titleWidth + valueWidth + 0);
      const y = startY + row * rowHeight;

      // Fondo gris para el título
      doc.setFillColor(230, 230, 230);
      doc.setDrawColor(200);
      doc.rect(x, y, titleWidth, rowHeight, 'FD');

      // Fondo blanco para el valor
      doc.setFillColor(255, 255, 255);
      doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

      // Texto del título
      doc.setTextColor(0);
      doc.setFont("helvetica", "bold");
      doc.text(cdaVehiculo[i][0], x + 2, y + 5.5);

      // Texto del valor
      doc.setFont("helvetica", "normal");
      doc.text(String(cdaVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
      
      
    }

    if (vehiculo.servicio === 1) {
      doc.setFillColor(230, 230, 230); // Gris claro y moderno
      doc.setDrawColor(200); // Borde gris suave
      doc.roundedRect(5, y + 146, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos  
      // Estilo del texto
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40); // Gris oscuro
      doc.text("REVISIÓN BIMESTRAL", 105, y + 154, { align: "center" });

      doc.setFontSize(9);
    const bimestral = vehiculo.historialBimestral?.[0];

      const bimVehiculo = [
        [
          "CDA:",
          bimestral?.empresa?.nombre
            ?.replace("CENTRO DE DIAGNOSTICO AUTOMOTOR", "CDA") ?? "SIN DATO"
        ],
        ["ID CDA:", bimestral?.centro_diagnostico ?? "SIN DATO"],
        [
          "EXPEDICIÓN:",
          bimestral?.ultima_revision
            ? this.formatFechaDDMMYYYY(bimestral.ultima_revision)
            : "SIN DATO"
        ],
        [
          "VENCIMIENTO:",
          bimestral?.proxima_revision
            ? this.formatFechaDDMMYYYY(bimestral.proxima_revision)
            : "SIN DATO"
        ],
        ["ESTADO:", bimestral?.estadoCalculado?.estado ?? "SIN DATO"]
      ];
      doc.setFontSize(9);
      startY = 37 + 156;
      for (let i = 0; i < bimVehiculo.length; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;

        const x = startX + col * (titleWidth + valueWidth + 0);
        const y = startY + row * rowHeight;

        // Fondo gris para el título
        doc.setFillColor(230, 230, 230);
        doc.setDrawColor(200);
        doc.rect(x, y, titleWidth, rowHeight, 'FD');

        // Fondo blanco para el valor
        doc.setFillColor(255, 255, 255);
        doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

        // Texto del título
        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.text(bimVehiculo[i][0], x + 2, y + 5.5);

        // Texto del valor
        doc.setFont("helvetica", "normal");
        doc.text(String(bimVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
      }
      
    }


   // doc.addPage();

    if (vehiculo.servicio === 1) {
      doc.addPage();
      const tarjetasOperaciones = vehiculo.tarjetasOperaciones?.[0];
      const tarjetaVehiculo = [
        ["ID TARJETA:", tarjetasOperaciones?.numero_tarjeta || "SIN DATO"],
        ["ESTADO:", tarjetasOperaciones?.estadoCalculado?.estado || "SIN DATO"],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(tarjetasOperaciones?.fecha_expedicion || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(tarjetasOperaciones?.fecha_vencimiento || '')],

      ];
      renderPolizaSection(doc, "TARJETA DE OPERACIÓN", tarjetaVehiculo as [string, string][], 10);

      const contractual = vehiculo.historialContractual?.[0];
      const contVehiculo = [
        ["ASEGURADORA:", contractual?.empresa?.nombre || "SIN DATO"],
        ["ID ASEGURADORA:", contractual?.aseguradoraRCC || "SIN DATO"],
        ["NUMERO:", contractual?.numeroRCC || "SIN DATO"],
        ["INTERMEDIARIA:", contractual?.intermediariaRCC || "SIN DATO"],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(contractual?.fecha_expedicionRCC || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(contractual?.fecha_vencimientoRCC || '')],
        ["ESTADO:", contractual?.estadoCalculado?.estado || "SIN DATO"]
      ];

      renderPolizaSection(
        doc,
        "PÓLIZA RESPONSABILIDAD CIVIL CONTRACTUAL",
        contVehiculo as [string, string][],
        40
      );

      const extracontractual = vehiculo.historialExtraContractual?.[0];
      const extVehiculo = [
        ["ASEGURADORA:", extracontractual?.empresa?.nombre || "SIN DATO"],
        ["ID ASEGURADORA:", extracontractual?.aseguradoraRCE || "SIN DATO"],
        ["NUMERO:", extracontractual?.numeroRCE || "SIN DATO"],
        ["INTERMEDIARIA:", extracontractual?.intermediariaRCE || "SIN DATO"],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(extracontractual?.fecha_expedicionRCE || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(extracontractual?.fecha_vencimientoRCE || '')],
        ["ESTADO:", extracontractual?.estadoCalculado?.estado || "SIN DATO"]
      ];

      renderPolizaSection(doc, "PÓLIZA RESPONSABILIDAD CIVIL EXTRACONTRACTUAL", extVehiculo as [string, string][], 85);

      const todo = vehiculo.historialTodoRiesgo?.[0];
      const todoVehiculo = [
        ["ASEGURADORA:", todo?.empresa?.nombre || "SIN DATO"],
        ["ID ASEGURADORA:", todo?.aseguradoraTD || "SIN DATO"],
        ["NUMERO:", todo?.numeroTD || "SIN DATO"],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(todo?.fecha_expedicionTD || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(todo?.fecha_vencimientoTD || '')],
        ["ESTADO:", todo?.estadoCalculado?.estado || "SIN DATO"]
      ];

      renderPolizaSection(doc, "PÓLIZA TODO RIESGOS", todoVehiculo as [string, string][], 130);
     
     
     //  this.agregarHojaMantenimientos(doc, vehiculo.placa, this.mantenimientos);
      if(isMantenimientoIncluido) {
          if(this.mantenimientos?.length) {
         
           // this.generarReporteMantenimientos(doc, vehiculo.placa, this.mantenimientos);
          }
            
      }
      
    }

    if (isMantenimientoIncluido) {
     if (this.mantenimientos?.length) {
          this.generarReporteMantenimientos(doc, vehiculo.placa, this.mantenimientos);
        }
    }



    function renderPolizaSection(doc, title: string, data: [string, string][], yOffset: number) {
      const sectionTop = yOffset;
      const startY = yOffset + 12;

      // Header
      doc.setFillColor(230, 230, 230);
      doc.setDrawColor(200);
      doc.roundedRect(5, sectionTop, 206, 12, 0, 0, 'FD');
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40);
      doc.text(title, 105, sectionTop + 8, { align: "center" });

      // Data rows
      doc.setFontSize(9);
      for (let i = 0; i < data.length; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;
        const x = startX + col * (titleWidth + valueWidth);
        const y = startY + row * rowHeight;

        doc.setFillColor(230, 230, 230);
        doc.setDrawColor(200);
        doc.rect(x, y, titleWidth, rowHeight, 'FD');

        doc.setFillColor(255, 255, 255);
        doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.text(data[i][0], x + 2, y + 5.5);

        doc.setFont("helvetica", "normal");
        doc.text(String(data[i][1]), x + titleWidth + 2, y + 5.5);
      }
    }


    const pageCount = doc.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      this.addFooter(doc, i, pageCount);
    }

    //    this.mostrandoToast = false;
    const imageMap = this.layoutConfig;
    try {
      // Todo el proceso de generación del PDF

      await this.addImagesToPdfConPaginas(
        doc,
        this.gpcGoogle,
        this.layoutConfig
      );

      // Descargar el PDF si todavía no lo haces
      // doc.save(`Ficha_Calidad_${placa}.pdf`);

    } catch (error) {
      console.error('Error generando el PDF:', error);

    } finally {
      //  this.mostrandoToast = false;
      this.loadingService.ocultar();
    }

  }

private agregarHojaMantenimientos(
  doc: jsPDF,
  placa: string,
  mantenimientos: Mantenimiento[]
): void {
  doc.addPage('letter', 'portrait');

  const margenIzquierdo = 12;
  const anchoPagina = doc.internal.pageSize.getWidth();
  const altoPagina = doc.internal.pageSize.getHeight();
  const anchoUtil = anchoPagina - margenIzquierdo * 2;

  let y = 18;

  // Encabezado de la hoja
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text('HISTORIAL DE MANTENIMIENTOS - ULTIMOS SEIS (06) MESES', anchoPagina / 2, y, {
    align: 'center'
  });

  y += 9;

/*   doc.setFontSize(10);
  doc.text(`Vehículo: ${placa}`, margenIzquierdo, y);

  y += 9;
 */
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);

const columnas = [
  { titulo: 'FECHA', ancho: 23 },
  { titulo: 'TIPO / SERVICIO', ancho: 34 },
  { titulo: 'KM', ancho: 17 },
  { titulo: 'TALLER', ancho: 32 },
  { titulo: 'OBSERVACIONES', ancho: 42 },
  { titulo: 'COSTO', ancho: anchoUtil - 148 }
];

const dibujarEncabezado = () => {
  const altoEncabezado = 9;

  // Ancho total de todas las columnas
  const anchoTotal = columnas.reduce(
    (total, columna) => total + columna.ancho,
    0
  );

  // Dibujar fondo gris para TODA la fila
  doc.setFillColor(91, 91, 91);
  doc.rect(
    margenIzquierdo,
    y,
    anchoTotal,
    altoEncabezado,
    'F'
  );

  // Dibujar bordes y títulos de cada columna
  let x = margenIzquierdo;

  doc.setDrawColor(210, 210, 210);
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);

  for (const columna of columnas) {
    doc.rect(
      x,
      y,
      columna.ancho,
      altoEncabezado,
      'S'
    );

    doc.text(
      columna.titulo,
      x + 1.5,
      y + 5.7,
      { maxWidth: columna.ancho - 3 }
    );

    x += columna.ancho;
  }

  // Restaurar estilos
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);

  y += altoEncabezado;
};
  dibujarEncabezado();

  let costoTotal = 0;

  if (!mantenimientos.length) {
    doc.setFontSize(10);
    doc.text(
      'No se encontraron mantenimientos para el periodo consultado.',
      margenIzquierdo,
      y + 8
    );
    return;
  }

  for (const mantenimiento of mantenimientos) {
    // Ajusta los nombres alternativos a los campos reales
    // de tu interfaz Mantenimiento.
     console.log(mantenimiento);
    const fecha = String(
      (mantenimiento as any).fecha ??
      (mantenimiento as any).fecha_mantenimiento ??
      ''
    );

    const tipo = String(
      (mantenimiento as any).tipoMantenimiento.nombre ??
      ''
    );

    const km = String(
      (mantenimiento as any).km ??
      (mantenimiento as any).kilometraje ??
      ''
    );

    const taller = String(
      (mantenimiento as any).taller ?? ''
    );

    const observacion = String(
      (mantenimiento as any).observacion ?? ''
    );

    const costo = Number(
      (mantenimiento as any).vrpagos ??
      (mantenimiento as any).costo ??
      0
    ) || 0;

    costoTotal += costo;

    const valores = [
      fecha.substring(0, 10),
      tipo,
      km,
      taller,
      observacion,
      `$${costo.toLocaleString('es-CO')}`
    ];

    const textos = valores.map((valor, i) =>
      doc.splitTextToSize(
        valor,
        columnas[i].ancho - 3
      )
    );

    const altoFila = Math.max(
      10,
      ...textos.map(texto => texto.length * 3.5 + 4)
    );

    // Salto de página cuando no cabe la siguiente fila
    if (y + altoFila > altoPagina - 25) {
      doc.addPage('letter', 'portrait');
      y = 18;
      dibujarEncabezado();
    }

    let x = margenIzquierdo;

    columnas.forEach((columna, i) => {
      doc.setDrawColor(210, 210, 210);
      doc.rect(x, y, columna.ancho, altoFila);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);

      doc.text(textos[i], x + 1.5, y + 4, {
        maxWidth: columna.ancho - 3
      });

      x += columna.ancho;
    });

    y += altoFila;
  }

  // Total de costos
  if (y + 12 > altoPagina - 15) {
    doc.addPage('letter', 'portrait');
    y = 20;
  }

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);

  doc.text(
    `TOTAL DE MANTENIMIENTOS: $${costoTotal.toLocaleString('es-CO')}`,
    anchoPagina - margenIzquierdo,
    y + 8,
    { align: 'right' }
  );
}
 obtenerFechaSeisMesesAtras(): string {
  const fecha = new Date();
  fecha.setMonth(fecha.getMonth() - 6);

  const anio = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');

  return `${anio}-${mes}-${dia}`;
}
   
   
   
     //ficha fotografica
  async ExportarFichaFotografica(
    placa: string,
    servicio: number
  ): Promise<void> {

    this.loadingService.mostrar(
      'Preparando ficha fotográfica',
      [
        {
          id: 'preparando',
          nombre: 'Preparando ficha',
          icono: '📝',
          visible: true,
          estado: 'completado'
        },
        {
          id: 'vehiculo',
          nombre: 'Datos del vehículo',
          icono: '🚍',
          visible: true,
          estado: 'cargando'
        },
        {
          id: 'documentos',
          nombre: 'Validando documentos',
          icono: '📄',
          visible: true,
          estado: 'pendiente'
        },
        {
          id: 'pdf',
          nombre: 'Generando PDF',
          icono: '📑',
          visible: true,
          estado: 'pendiente'
        }
      ]
    );

    try {
      // Conserva aquí el resto de tu código actual.
      this.loadingService.actualizarPaso(
        'documentos',
        { estado: 'cargando' },
        'Validando documentos del vehículo'
      );
      this.ValidarDocumentos(servicio, placa, 1);
      //  this.mostrandoToast = true;
      const vehiculo = this.vehicles.find(v => v.placa === placa);
      console.log(vehiculo);
      if (!vehiculo) {
        console.error("Vehículo no encontrado");
        return;
      }
      this.loadingService.actualizarPaso(
        'vehiculo',
        { estado: 'completado' },
        'Datos del vehículo encontrados'
      );

      this.loadingService.actualizarPaso(
        'documentos',
        { estado: 'completado' },
        'Validación de documentos finalizada'
      );

      this.loadingService.actualizarPaso(
        'pdf',
        { estado: 'cargando' },
        'Construyendo ficha fotográfica'
      );
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "letter",
      });

      this.addHeader(doc, 'FICHA FOTOGRÁFICA');
      await this.addHeaderImages(doc, this.gpcGoogle,
        {
          supertransporte: { path: "ministerio/supertransporte.png", x: 170, y: 7, w: 35, h: 12 },
          logo: { path: `${this.administraciones[0].nit}/logos/logo.png`, x: this.posicionX, y: this.posicionY, w: this.ancho, h: this.altura },
        },
      );

      let y = 35;
      // Estilo del rectángulo gris
      doc.setFillColor(230, 230, 230); // Gris claro y moderno
      doc.setDrawColor(200); // Borde gris suave
      doc.roundedRect(5, 25, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos

      // Estilo del texto
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40); // Gris oscuro
      doc.text("INFORMACIÓN DEL VEHÍCULO", 105, 33, { align: "center" });

      const infoVehiculo = [
        ["PLACA:", vehiculo.placa],
        ["EMPRESA:", vehiculo.nitEmpresa],
        ["MARCA:", vehiculo.marcas?.marca || ''],
        ["CLASE:", vehiculo.tipoVehiculo?.tipos || ''],
        ["MODELO:", vehiculo.modelo],
        ["CAPACIDAD:", vehiculo.capacidad + " Pasajeros"],
        ["COLOR:", vehiculo.color],
        ["LÍNEA:", vehiculo.linea],
        ["CARROCERÍA:", vehiculo.carroceria],
        ["CILINDRAJE:", vehiculo.cilindraje],
        ["MOTOR:", vehiculo.motor],
        ["SERIE:", vehiculo.serie],
        ["CHASIS:", vehiculo.chasis],
        ["# MATRICULA:", vehiculo.matricula],
        ["ORGANISMO:", vehiculo.organismo],

        ["AFILIACIÓN:", vehiculo.afiliacion],
        ["RELACIÓN:", vehiculo.tipoRelacion?.relacion || ''],
        ["PROPIETARIO:", `${vehiculo.propietario?.primernombre} ${vehiculo.propietario?.segundonombre} ${vehiculo.propietario?.papellidos} ${vehiculo.propietario?.seapellidos}`.trim()]
      ];

      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      let startY = 37;
      const rowHeight = 7;
      const titleWidth = 35;
      const valueWidth = 68;
      const startX = 5;

      for (let i = 0; i < infoVehiculo.length; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;

        const x = startX + col * (titleWidth + valueWidth + 0);
        const y = startY + row * rowHeight;

        // Fondo gris para el título
        doc.setFillColor(230, 230, 230);
        doc.setDrawColor(200);
        doc.rect(x, y, titleWidth, rowHeight, 'FD');

        // Fondo blanco para el valor
        doc.setFillColor(255, 255, 255);
        doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

        // Texto del título
        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.text(infoVehiculo[i][0], x + 2, y + 5.5);

        // Texto del valor
        doc.setFont("helvetica", "normal");
        doc.text(String(infoVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
      }



      doc.setFillColor(230, 230, 230); // Gris claro y moderno
      doc.setDrawColor(200); // Borde gris suave
      doc.roundedRect(5, y + 70, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos  
      // Estilo del texto
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40); // Gris oscuro
      doc.text("SEGURO OBLIGATORIO DE ACCIDENTES DE TRANSITO (SOAT)", 105, y + 77, { align: "center" });

      doc.setFontSize(9);
      // console.log(vehiculo.historialSoat[0]);
      const soat = vehiculo.historialSoat?.[0];

      const soatVehiculo = [
        ["ASEGURADORA:", soat?.empresa?.nombre || ''],
        ["ID SOAT:", soat?.id_soat || ''],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(soat?.fecha_soat || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(soat?.vencimiento_soat || '')],
        ["ESTADO:", soat?.estadoCalculado?.estado || '']


      ];

      startY = 37 + 80;
      for (let i = 0; i < soatVehiculo.length; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;

        const x = startX + col * (titleWidth + valueWidth + 0);
        const y = startY + row * rowHeight;

        // Fondo gris para el título
        doc.setFillColor(230, 230, 230);
        doc.setDrawColor(200);
        doc.rect(x, y, titleWidth, rowHeight, 'FD');

        // Fondo blanco para el valor
        doc.setFillColor(255, 255, 255);
        doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

        // Texto del título
        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.text(soatVehiculo[i][0], x + 2, y + 5.5);

        // Texto del valor
        doc.setFont("helvetica", "normal");
        doc.text(String(soatVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
      }



      doc.setFillColor(230, 230, 230); // Gris claro y moderno
      doc.setDrawColor(200); // Borde gris suave
      doc.roundedRect(5, y + 108, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos  
      // Estilo del texto
      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(40, 40, 40); // Gris oscuro
      doc.text("REVISIÓN TÉCNICO MECÁNICA (RTM)", 105, y + 116, { align: "center" });

      doc.setFontSize(9);
      const cda = vehiculo.historialCda?.[0];
      const cdaVehiculo = [
        ["CDA:", cda?.empresa?.nombre.replace("CENTRO DE DIAGNOSTICO AUTOMOTOR", "CDA") || ''],
        ["ID CDA:", cda?.idcda || ''],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(cda?.fechacda || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(cda?.vcda || '')],
        ["ESTADO:", cda?.estadoCalculado?.estado || '']


      ];
      
      doc.setFontSize(9);
      startY = 37 + 118;
      for (let i = 0; i < cdaVehiculo.length; i++) {
        const row = Math.floor(i / 2);
        const col = i % 2;

        const x = startX + col * (titleWidth + valueWidth + 0);
        const y = startY + row * rowHeight;

        // Fondo gris para el título
        doc.setFillColor(230, 230, 230);
        doc.setDrawColor(200);
        doc.rect(x, y, titleWidth, rowHeight, 'FD');

        // Fondo blanco para el valor
        doc.setFillColor(255, 255, 255);
        doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

        // Texto del título
        doc.setTextColor(0);
        doc.setFont("helvetica", "bold");
        doc.text(cdaVehiculo[i][0], x + 2, y + 5.5);

        // Texto del valor
        doc.setFont("helvetica", "normal");
        doc.text(String(cdaVehiculo[i][1]), x + titleWidth + 2, y + 5.5);


        
      }

      if (vehiculo.servicio === 1) {
        doc.setFillColor(230, 230, 230); // Gris claro y moderno
        doc.setDrawColor(200); // Borde gris suave
        doc.roundedRect(5, y + 146, 206, 12, 0, 0, 'FD'); // x, y, w, h, rx, ry, estilo F=fill, D=draw, FD=ambos  
        // Estilo del texto
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(40, 40, 40); // Gris oscuro
        doc.text("REVISIÓN BIMESTRAL", 105, y + 154, { align: "center" });

        doc.setFontSize(9);
        const bimestral = vehiculo.historialBimestral?.[0];
        const bimVehiculo = [
          ["CDA:", bimestral?.empresa?.nombre.replace("CENTRO DE DIAGNOSTICO AUTOMOTOR", "CDA") || ''],
          ["ID CDA:", bimestral?.centro_diagnostico || ''],
          ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(bimestral?.ultima_revision || '')],
          ["VENCIMIENTO:", this.formatFechaDDMMYYYY(bimestral?.proxima_revision || '')],
          ["ESTADO:", bimestral?.estadoCalculado?.estado || '']
        ];

        doc.setFontSize(9);
        startY = 37 + 156;
        for (let i = 0; i < bimVehiculo.length; i++) {
          const row = Math.floor(i / 2);
          const col = i % 2;

          const x = startX + col * (titleWidth + valueWidth + 0);
          const y = startY + row * rowHeight;

          // Fondo gris para el título
          doc.setFillColor(230, 230, 230);
          doc.setDrawColor(200);
          doc.rect(x, y, titleWidth, rowHeight, 'FD');

          // Fondo blanco para el valor
          doc.setFillColor(255, 255, 255);
          doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

          // Texto del título
          doc.setTextColor(0);
          doc.setFont("helvetica", "bold");
          doc.text(bimVehiculo[i][0], x + 2, y + 5.5);

          // Texto del valor
          doc.setFont("helvetica", "normal");
          doc.text(String(bimVehiculo[i][1]), x + titleWidth + 2, y + 5.5);
        }
      }



      // console.log(vehiculo);
      if (Number(vehiculo.servicio) === 1) {
        doc.addPage();
        const tarjetasOperaciones = vehiculo.tarjetasOperaciones?.[0];
        const tarjetaVehiculo = [
          ["ID TARJETA:", tarjetasOperaciones?.numero_tarjeta || "SIN DATO"],
          ["ESTADO:", tarjetasOperaciones?.estadoCalculado?.estado || "SIN DATO"],
          ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(tarjetasOperaciones?.fecha_expedicion || '')],
          ["VENCIMIENTO:", this.formatFechaDDMMYYYY(tarjetasOperaciones?.fecha_vencimiento || '')],

        ];
        renderPolizaSection(doc, "TARJETA DE OPERACIÓN", tarjetaVehiculo as [string, string][], 10);

        const contractual = vehiculo.historialContractual?.[0];
        const contVehiculo = [
          ["ASEGURADORA:", contractual?.empresa?.nombre || "SIN DATO"],
          ["ID ASEGURADORA:", contractual?.aseguradoraRCC || "SIN DATO"],
          ["NUMERO:", contractual?.numeroRCC || "SIN DATO"],
          ["INTERMEDIARIA:", contractual?.intermediariaRCC || "SIN DATO"],
          ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(contractual?.fecha_expedicionRCC || '')],
          ["VENCIMIENTO:", this.formatFechaDDMMYYYY(contractual?.fecha_vencimientoRCC || '')],
          ["ESTADO:", contractual?.estadoCalculado?.estado || "SIN DATO"]
        ];

        renderPolizaSection(
          doc,
          "PÓLIZA RESPONSABILIDAD CIVIL CONTRACTUAL",
          contVehiculo as [string, string][],
          40
        );

      const extracontractual = vehiculo.historialExtraContractual?.[0];
      const extVehiculo = [
        ["ASEGURADORA:", extracontractual?.empresa?.nombre || "SIN DATO"],
        ["ID ASEGURADORA:", extracontractual?.aseguradoraRCE || "SIN DATO"],
        ["NUMERO:", extracontractual?.numeroRCE || "SIN DATO"],
        ["INTERMEDIARIA:", extracontractual?.intermediariaRCE || "SIN DATO"],
        ["EXPEDICIÓN:", this.formatFechaDDMMYYYY(extracontractual?.fecha_expedicionRCE || '')],
        ["VENCIMIENTO:", this.formatFechaDDMMYYYY(extracontractual?.fecha_vencimientoRCE || '')],
        ["ESTADO:", extracontractual?.estadoCalculado?.estado || "SIN DATO"]
      ];
        renderPolizaSection(doc, "PÓLIZA RESPONSABILIDAD CIVIL EXTRACONTRACTUAL", extVehiculo as [string, string][], 85);

        const todo = vehiculo.historialTodoRiesgo?.[0];
        const todoVehiculo = [
          ["ASEGURADORA:", todo?.empresa?.nombre || "SIN DATO"],
          ["ID ASEGURADORA:", todo?.aseguradoraTD || "SIN DATO"],
          ["NUMERO:", todo?.numeroTD || "SIN DATO"],
          ["EXPEDICIÓN:", todo?.fecha_expedicionTD || "SIN DATO"],
          ["VENCIMIENTO:", todo?.fecha_vencimientoTD || "SIN DATO"],
          ["ESTADO:", todo?.estadoCalculado?.estado || "SIN DATO"]
        ];

        renderPolizaSection(doc, "PÓLIZA TODO RIESGOS", todoVehiculo as [string, string][], 130);
        //doc.addPage();

        const imageMap = this.layoutConfig;
        await this.addphotoToPdf(doc, this.gpcGoogle, imageMap);
      }





      function renderPolizaSection(doc, title: string, data: [string, string][], yOffset: number) {
        const sectionTop = yOffset;
        const startY = yOffset + 12;

        // Header
        doc.setFillColor(230, 230, 230);
        doc.setDrawColor(200);
        doc.roundedRect(5, sectionTop, 206, 12, 0, 0, 'FD');
        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(40, 40, 40);
        doc.text(title, 105, sectionTop + 8, { align: "center" });

        // Data rows
        doc.setFontSize(9);
        for (let i = 0; i < data.length; i++) {
          const row = Math.floor(i / 2);
          const col = i % 2;
          const x = startX + col * (titleWidth + valueWidth);
          const y = startY + row * rowHeight;

          doc.setFillColor(230, 230, 230);
          doc.setDrawColor(200);
          doc.rect(x, y, titleWidth, rowHeight, 'FD');

          doc.setFillColor(255, 255, 255);
          doc.rect(x + titleWidth, y, valueWidth, rowHeight, 'FD');

          doc.setTextColor(0);
          doc.setFont("helvetica", "bold");
          doc.text(data[i][0], x + 2, y + 5.5);

          doc.setFont("helvetica", "normal");
          doc.text(String(data[i][1]), x + titleWidth + 2, y + 5.5);
        }
      }

      const pageCount = doc.getNumberOfPages();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        this.addFooter(doc, i, pageCount);
      }

      //this.mostrandoToast = false;
      // GENERAR PDF
      const blob = doc.output("blob");
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      this.loadingService.actualizarPaso(
        'pdf',
        { estado: 'completado' },
        'Ficha fotográfica generada correctamente'
      );

    } catch (error) {
      console.error('Error generando la ficha fotográfica:', error);

      this.loadingService.actualizarPaso(
        'pdf',
        { estado: 'error' },
        'No fue posible generar la ficha fotográfica'
      );

    } finally {
      this.mostrandoToast = false;
      this.loadingService.ocultar();

    }
  }

  private cargarDataAdmin():void{
  this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
       // console.log(data);
          this.administraciones = data;       
          
        this.administraciones[0].nit;
        this.altura = data[0].dimensionLogo.h;      // "8"
        this.ancho = data[0].dimensionLogo.w;       // "40"
        this.posicionX = data[0].dimensionLogo.x;   // 10
        this.posicionY = data[0].dimensionLogo.y;  
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
 }

 // Descargar PDFs si existen
async  fetchPdf(url: string): Promise<Uint8Array> {
  const response = await fetch(url);
  if (!response.ok) throw new Error("No se pudo descargar el PDF");
  return new Uint8Array(await response.arrayBuffer());
}

 // Helper function to format date to DD/MM/YYYY
  formatFechaDDMMYYYY(fecha: string | Date): string {
    if (!fecha) return '';

    // Si viene como string ('2026-10-03' o ISO '2026-10-03T00:00:00.000Z'),
    // se toma la fecha literal para evitar el desfase de zona horaria
    // (new Date('2026-10-03') se interpreta como UTC y en UTC-5 resta un día)
    if (typeof fecha === 'string') {
      const match = fecha.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        const [, year, month, day] = match;
        return `${day}/${month}/${year}`;
      }
    }

    const date = new Date(fecha);
    if (isNaN(date.getTime())) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  
private agregarTimelineMantenimientos(
  doc: jsPDF,
  placa: string,
  mantenimientos: Mantenimiento[]
): void {
  const anchoPagina = doc.internal.pageSize.getWidth();
  const altoPagina = doc.internal.pageSize.getHeight();

  const margen = 14;
  const anchoUtil = anchoPagina - margen * 2;

  const colorRojo: [number, number, number] = [61, 61,61];
  const colorGris: [number, number, number] = [91, 91, 91];
  const colorTexto: [number, number, number] = [55, 55, 55];
  const colorBorde: [number, number, number] = [220, 220, 220];
  const colorFondo: [number, number, number] = [248, 248, 248];

  const xLinea = margen + 5;
  const xTarjeta = margen + 17;
  const anchoTarjeta = anchoUtil - 17;

  let y = 0;
  let costoTotal = 0;
  let paginaTimeline = false;

  const texto = (valor: unknown): string => {
    if (valor === null || valor === undefined || valor === '') {
      return 'Sin información';
    }

    return String(valor);
  };

  const obtenerCampo = (
    registro: Mantenimiento,
    campos: string[]
  ): unknown => {
    const datos = registro as unknown as Record<string, unknown>;

    for (const campo of campos) {
      if (datos[campo] !== undefined && datos[campo] !== null) {
        return datos[campo];
      }
    }

    return '';
  };

  const formatearFecha = (valor: unknown): string => {
    if (!valor) return 'Sin fecha';

    const fecha = String(valor).substring(0, 10);
    const partes = fecha.split('-');

    if (partes.length === 3) {
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    }

    return fecha;
  };

  const formatearCosto = (valor: unknown): number => {
    const numero = Number(valor);
    return Number.isFinite(numero) ? numero : 0;
  };

  const dibujarEncabezado = () => {
    doc.setFillColor(...colorGris);
    doc.rect(0, 0, anchoPagina, 32, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(15);

    doc.text(
      'HISTORIAL DE MANTENIMIENTOS',
      margen,
      13
    );

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);

    doc.text(`Vehículo: ${placa}`, margen, 21);

    doc.text(
      `Registros: ${mantenimientos.length}`,
      anchoPagina - margen,
      21,
      { align: 'right' }
    );

    doc.setFillColor(...colorRojo);
    doc.rect(margen, 29, 35, 1.5, 'F');

    doc.setTextColor(...colorTexto);
    y = 43;
    paginaTimeline = true;
  };

  const nuevaPagina = () => {
    doc.addPage('letter', 'portrait');
    dibujarEncabezado();
  };

  // Orden cronológico descendente: más reciente primero.
  const registros = [...mantenimientos].sort((a, b) => {
    const fechaA = String(
      obtenerCampo(a, ['fecha', 'fecha_mantenimiento', 'fecha_servicio'])
    );

    const fechaB = String(
      obtenerCampo(b, ['fecha', 'fecha_mantenimiento', 'fecha_servicio'])
    );

    return fechaB.localeCompare(fechaA);
  });

  // Agregar hoja independiente al PDF.
  nuevaPagina();

  if (!registros.length) {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);

    doc.text(
      'No se encontraron mantenimientos en el periodo consultado.',
      margen,
      y
    );

    return;
  }

  registros.forEach((mantenimiento, indice) => {

    const fecha = formatearFecha(
      obtenerCampo(mantenimiento, [
        'fecha',
        'fecha_mantenimiento',
        'fecha_servicio'
      ])
    );
const tipoCodigo = mantenimiento.tipoMantenimiento?.nombre ?? '';



    const tipo =tipoCodigo;

    const kilometraje = texto(
      obtenerCampo(mantenimiento, [
        'km',
        'kilometraje',
        'km_actual',
        'odometro'
      ])
    );

    const taller = texto(
      obtenerCampo(mantenimiento, [
        'taller',
        'nombre_taller',
        'proveedor',
        'empresa'
      ])
    );

    const observaciones = texto(
      obtenerCampo(mantenimiento, [
        'observacion',
        'observaciones',
        'descripcion',
        'detalle'
      ])
    );

    const costo = formatearCosto(
      obtenerCampo(mantenimiento, [
        'vrpagos',
        'costo',
        'costo_total',
        'valor',
        'total'
      ])
    );

    costoTotal += costo;

    // Calcular la altura según la longitud del texto.
    const anchoTexto = anchoTarjeta - 10;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);

    const lineasObservacion = doc.splitTextToSize(
      observaciones,
      anchoTexto
    );

    const lineasTaller = doc.splitTextToSize(
      `Taller: ${taller}`,
      anchoTexto
    );

    const altoTarjeta = Math.max(
      39,
      25 +
      lineasTaller.length * 4 +
      lineasObservacion.length * 4
    );

    // Comprobar espacio disponible antes de dibujar.
    if (y + altoTarjeta > altoPagina - 22) {
      nuevaPagina();
    }

    // Línea vertical del timeline.
    doc.setDrawColor(...colorBorde);
    doc.setLineWidth(0.7);

    if (indice < registros.length - 1) {
      doc.line(
        xLinea,
        y + 5,
        xLinea,
        y + altoTarjeta + 9
      );
    }

    // Círculo del evento.
    doc.setFillColor(...colorRojo);
    doc.setDrawColor(255, 255, 255);
    doc.circle(xLinea, y + 5, 2.2, 'FD');

    // Fondo de la tarjeta.
    doc.setFillColor(...colorFondo);
    doc.setDrawColor(...colorBorde);

    doc.roundedRect(
      xTarjeta,
      y,
      anchoTarjeta,
      altoTarjeta,
      2,
      2,
      'FD'
    );

    // Barra roja lateral.
    doc.setFillColor(...colorRojo);
    doc.rect(
      xTarjeta,
      y + 3,
      1.2,
      altoTarjeta - 6,
      'F'
    );

    const xTexto = xTarjeta + 6;
    const xDerecha = xTarjeta + anchoTarjeta - 5;

    // Fecha.
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...colorGris);

    doc.text(fecha, xTexto, y + 7);

    // Tipo de mantenimiento.
 // Badge de tipo de mantenimiento.
const coloresTipo =this.obtenerColorTipo(tipo);

doc.setFont('helvetica', 'bold');
doc.setFontSize(7.5);

const tipoBadge = tipo.toUpperCase();
const anchoBadge =
  doc.getTextWidth(tipoBadge) + 8;
const altoBadge = 6;

const xBadge = xTexto;
const yBadge = y + 10;

// Fondo de la badge.
doc.setFillColor(...coloresTipo.fondo);

doc.roundedRect(
  xBadge,
  yBadge,
  anchoBadge,
  altoBadge,
  2,
  2,
  'F'
);

// Texto de la badge.
doc.setTextColor(...coloresTipo.texto);

doc.text(
  tipoBadge,
  xBadge + 4,
  yBadge + 4
);

    // Costo alineado a la derecha.
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(...colorTexto);

    doc.text(
      `$${costo.toLocaleString('es-CO')}`,
      xDerecha,
      y + 7,
      { align: 'right' }
    );

    // Kilometraje.
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...colorTexto);

    const yDetalle = y + 20;

    doc.text(
      `Kilometraje: ${kilometraje} km`,
      xTexto,
      yDetalle
    );

    // Taller y observaciones.
    let yTexto = yDetalle + 5;

    doc.text(lineasTaller, xTexto, yTexto);
    yTexto += lineasTaller.length * 4;

    doc.setFont('helvetica', 'italic');

    doc.text(
      lineasObservacion,
      xTexto,
      yTexto
    );

    y += altoTarjeta + 9;
  });

  // Resumen final de costos.
  if (y + 18 > altoPagina - 10) {
    nuevaPagina();
  }

  y += 3;

  doc.setFillColor(...colorGris);
  doc.roundedRect(
    margen,
    y,
    anchoUtil,
    13,
    2,
    2,
    'F'
  );

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(255, 255, 255);

  doc.text(
    `TOTAL DE MANTENIMIENTOS: $${costoTotal.toLocaleString('es-CO')}`,
    anchoPagina - margen - 4,
    y + 8.5,
    { align: 'right' }
  );

  // Restaurar color de texto.
  doc.setTextColor(0, 0, 0);
}


private async generarReporteMantenimientos(
  doc: jsPDF,
  placa: string,
  mantenimientos: Mantenimiento[],
): Promise<void> {
 // console.log('Generando reporte de mantenimientos para la placa:', placa);
  const fechaInicial = this.obtenerFechaSeisMesesAtras();
  const fechaFinal = new Date().toISOString().substring(0, 10);

  const respuesta = await firstValueFrom(
    this.mantenimientoService.buscarMantenimientosPorFiltros(
      [placa],
      fechaInicial,
      fechaFinal
    )
  );

  mantenimientos = respuesta.vehiculos.find(
    vehiculo => vehiculo.placa === placa
  )?.mantenimientos ?? [];

  // Hoja de resumen estadístico.
  this.agregarResumenMantenimientos(
    doc,
    placa,
    mantenimientos
  );

  // Timeline de mantenimientos.
  this.agregarTimelineMantenimientos(
    doc,
    placa,
    mantenimientos
  );
}

private agregarResumenMantenimientos(
  doc: jsPDF,
  placa: string,
  mantenimientos: Mantenimiento[]
): void {
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const margen = 12;
  const ancho = W - margen * 2;

  const gris: [number, number, number] = [91, 91, 91];
  const grisOscuro: [number, number, number] = [61, 61, 61];
  const texto: [number, number, number] = [50, 50, 50];
  const borde: [number, number, number] = [220, 220, 220];

  const registros = mantenimientos ?? [];
  const cantidad = registros.length;

  const dinero = (valor: number): string =>
    '$' + Math.round(valor).toLocaleString('es-CO');

  const obtenerCosto = (m: Mantenimiento): number => {
    const valor = Number(m.vrpagos ?? 0);
    return Number.isFinite(valor) ? valor : 0;
  };

  // Agrupar por tipo de mantenimiento.
  const grupos = new Map<
    string,
    { cantidad: number; costoTotal: number }
  >();

  for (const m of registros) {
    const tipo =
      m.tipoMantenimiento?.nombre?.trim() ||
      m.tipo ||
      'SIN INFORMACIÓN';

    const grupo = grupos.get(tipo) ?? {
      cantidad: 0,
      costoTotal: 0
    };

    grupo.cantidad++;
    grupo.costoTotal += obtenerCosto(m);
    grupos.set(tipo, grupo);
  }

  const categorias = Array.from(grupos.entries())
    .map(([tipo, datos]) => ({ tipo, ...datos }))
    .sort((a, b) => b.cantidad - a.cantidad);

  const costoTotal = registros.reduce(
    (total, m) => total + obtenerCosto(m),
    0
  );

  const costoPromedio = cantidad
    ? costoTotal / cantidad
    : 0;

  const tipoFrecuente = categorias[0];

  // Crear una hoja independiente.
  doc.addPage('letter', 'portrait');

  // Encabezado.
  doc.setFillColor(...gris);
  doc.rect(0, 0, W, 31, 'F');

  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(15);
  doc.text('RESUMEN DE MANTENIMIENTOS', margen, 12);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(`Vehículo: ${placa}`, margen, 21);
  doc.text(`Registros: ${cantidad}`, W - margen, 21, {
    align: 'right'
  });

  doc.setFillColor(...grisOscuro);
  doc.rect(margen, 27, 34, 1.5, 'F');




const indicadores = [
  {
    titulo: 'TOTAL MANTENIMIENTOS',
    valor: String(cantidad),
    detalle: 'Intervenciones registradas',
    color: [190, 30, 45] as [number, number, number],
    fondo: [252, 235, 237] as [number, number, number],
    icono: 'herramienta'
  },
  {
    titulo: 'COSTO TOTAL',
    valor: dinero(costoTotal),
    detalle: 'Suma de los valores de los mantenimientos',
    color: [22, 135, 78] as [number, number, number],
    fondo: [231, 246, 237] as [number, number, number],
    icono: 'moneda'
  },
{
  titulo: 'TIPO DE MANTENIMIENTO MÁS FRECUENTE',
  valor: tipoFrecuente?.tipo ?? 'SIN DATOS',
  detalle: tipoFrecuente
    ? `${tipoFrecuente.cantidad} intervenciones (${
        (
          tipoFrecuente.cantidad /
          Math.max(cantidad, 1) * 100
        ).toFixed(0)
      }%)`
    : 'Sin intervenciones',
  color: [30, 100, 190] as [number, number, number],
  fondo: [232, 240, 253] as [number, number, number],
  icono: 'grafico'
},
  {
    titulo: 'COSTO PROMEDIO',
    valor: dinero(costoPromedio),
    detalle: 'Por intervención',
    color: [220, 100, 20] as [number, number, number],
    fondo: [255, 242, 226] as [number, number, number],
    icono: 'calculadora'
  }
];

const columnas = 2;
const filas = 2;
const gapX = 5;
const gapY = 5;

const cardW = (ancho - gapX) / columnas;
const cardH = 36;
const cardY = 38;

indicadores.forEach((item, i) => {
  const columna = i % columnas;
  const fila = Math.floor(i / columnas);

  const x = margen + columna * (cardW + gapX);
  const yCard = cardY + fila * (cardH + gapY);

  // Fondo y borde
  doc.setDrawColor(225, 228, 232);
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(x, yCard, cardW, cardH, 2.5, 2.5, 'FD');

  // Franja vertical
  doc.setFillColor(...item.color);
  doc.rect(x, yCard + 3, 2, cardH - 6, 'F');

  // Icono
  const iconX = x + 11;
  const iconY = yCard + 11;

  doc.setFillColor(...item.fondo);
  doc.circle(iconX, iconY, 5.5, 'F');

  doc.setTextColor(...item.color);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);

  const simbolos = ['+', '$', '▥', '$'];

  doc.text(
    simbolos[i],
    iconX,
    iconY + 1.5,
    { align: 'center' }
  );

  // Título
  doc.setTextColor(70, 78, 88);
  doc.setFontSize(8);

  doc.text(
    item.titulo,
    x + 21,
    yCard + 9
  );

  // Valor
  doc.setTextColor(...item.color);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(i === 2 ? 12 : 15);

  const valorLineas = doc.splitTextToSize(
    item.valor,
    cardW - 25
  );

  doc.text(valorLineas, x + 21, yCard + 19);

  // Detalle
  doc.setTextColor(95, 102, 112);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);

  const detalleLineas = doc.splitTextToSize(
    item.detalle,
    cardW - 25
  );

  doc.text(detalleLineas, x + 21, yCard + 27);
});

// Restaurar estilos.
doc.setTextColor(0, 0, 0);
doc.setDrawColor(0, 0, 0);
doc.setLineWidth(0.2);

  // Paneles de distribución y costos.
  const panelY = 120;
  const panelH = 67;
  const panelW = (ancho - 4) * 0.50;
  const panel2X = margen + panelW + 4;
  const panel2W = ancho - panelW - 4;

  doc.setDrawColor(...borde);
  doc.roundedRect(margen, panelY, panelW, panelH, 2, 2, 'S');
  doc.roundedRect(panel2X, panelY, panel2W, panelH, 2, 2, 'S');

  doc.setTextColor(30, 40, 65);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('DISTRIBUCIÓN POR TIPO', margen + 4, panelY + 7);
  doc.text('COSTOS POR TIPO', panel2X + 4, panelY + 7);

  const colores: [number, number, number][] = [
    [39, 125, 80],
    [45, 115, 200],
    [240, 145, 35],
    [190, 30, 45],
    [120, 120, 120]
  ];

  const maxCosto = Math.max(
    1,
    ...categorias.map(c => c.costoTotal)
  );

  categorias.slice(0, 5).forEach((cat, i) => {
    const filaY = panelY + 17 + i * 9;
    const color = colores[i % colores.length];
    const porcentaje = cantidad
      ? (cat.cantidad / cantidad) * 100
      : 0;

    // Distribución por cantidad.
    doc.setFillColor(...color);
    doc.circle(margen + 6, filaY - 1.5, 1.6, 'F');

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6.5);
    doc.setTextColor(...texto);

    doc.text(
      doc.splitTextToSize(cat.tipo, panelW - 43)[0],
      margen + 11,
      filaY
    );

    doc.setFont('helvetica', 'bold');
    doc.text(
      `${cat.cantidad} (${porcentaje.toFixed(0)}%)`,
      margen + panelW - 4,
      filaY,
      { align: 'right' }
    );

    // Costos por categoría.
    const labelW = 27;
    const valorW = 23;
    const barraX = panel2X + labelW;
    const barraW = panel2W - labelW - valorW - 8;
    const barraY = filaY - 3;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(6);

    doc.text(
      doc.splitTextToSize(cat.tipo, labelW - 2)[0],
      panel2X + 3,
      filaY
    );

    doc.setFillColor(240, 240, 240);
    doc.rect(barraX, barraY, barraW, 4, 'F');

    doc.setFillColor(...color);
    doc.rect(
      barraX,
      barraY,
      Math.max(0, barraW * cat.costoTotal / maxCosto),
      4,
      'F'
    );

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(6);
    doc.text(
      dinero(cat.costoTotal),
      panel2X + panel2W - 3,
      filaY,
      { align: 'right' }
    );
  });

  // Conclusión estadística.
  const resumenY = panelY + panelH + 9;

  doc.setTextColor(...gris);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('RESUMEN DEL PERIODO', margen, resumenY);

  doc.setTextColor(...texto);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);

  const lineasResumen = [
    `Intervenciones registradas: ${cantidad}.`,
    `Costo acumulado: ${dinero(costoTotal)}.`,
    tipoFrecuente
      ? `Categoría más frecuente: ${tipoFrecuente.tipo} (${tipoFrecuente.cantidad} registros).`
      : 'No hay categorías disponibles.'
  ];

  doc.text(lineasResumen, margen, resumenY + 7);

  // Pie de la hoja. El número de página se agrega después,
  // usando el ciclo general de addFooter().
  doc.setDrawColor(...borde);
  doc.line(margen, H - 16, W - margen, H - 16);

  doc.setTextColor(120, 120, 120);
  doc.setFontSize(7);
  doc.text(
    'Estadísticas calculadas a partir de los registros consultados.',
    margen,
    H - 10
  );

  // Restaurar color de texto.
  doc.setTextColor(0, 0, 0);
}

private obtenerColorTipo = (
  tipo: string
): {
  fondo: [number, number, number];
  texto: [number, number, number];
} => {
  const normalizado = tipo.trim().toUpperCase();

  if (normalizado.includes('CORRECTIVO')) {
    return {
      fondo: [253, 232, 232],
      texto: [190, 30, 45]
    };
  }

  if (normalizado.includes('PREDICTIVO Y PREVENTIVO')) {
    return {
      fondo: [255, 237, 213],
      texto: [180, 83, 9]
    };
  }

  if (normalizado.includes('PREDICTIVO')) {
    return {
      fondo: [219, 234, 254],
      texto: [29, 78, 216]
    };
  }

  if (normalizado.includes('PREVENTIVO')) {
    return {
      fondo: [220, 252, 231],
      texto: [22, 101, 52]
    };
  }

  return {
    fondo: [238, 238, 238],
    texto: [91, 91, 91]
  };
};
}



interface SignedUrlResponse {
  url?: string;
}